/**
 * A Petri spec is "on" under either convention: the boolean toggle ('true')
 * or the A/B variant ('B' = variant; 'A'/'false' = control). Values that are
 * already resolved booleans are passed through unchanged.
 */
export const isExperimentOn = value => value === true || value === 'true' || value === 'B';
export const LEGACY_SCOPE = 'premium-ng';

/** `clientBundle` values reach the browser via `__APP_PARAMS__.experiments`; `serverOnly` ones must not. */
export const EXPERIMENT_SCOPES = {
  clientBundle: {
    staticExternalPages: 'domains-static-external-pages',
    upgrade: 'domains-upgrade',
    purchaseApp: 'domains-purchase-app'
  },
  serverOnly: {
    serverlessServices: 'domains-serverless-services',
    storefrontServerless: 'domains-storefront-serverless',
    anonymousServerless: 'premium-domains-anonymous',
    domainsServerless: 'premium-domains-serverless'
  }
};

/** Structural, so this package stays free of the serverless runtime. */

const logScopeError = _ref => {
  let scope = _ref.scope,
    error = _ref.error;
  // eslint-disable-next-line no-console
  console.error(`[experiments] failed to conduct scope "${scope}"`, error);
};

/**
 * Conducts every scope in parallel and merges them into one bag. Later scopes
 * win, so pass `LEGACY_SCOPE` first. Never rejects: a scope that fails
 * contributes nothing.
 */
export const conductScopes = async function (conductor, scopes, onScopeError) {
  if (onScopeError === void 0) {
    onScopeError = logScopeError;
  }
  const bags = await Promise.all(scopes.map(async scope => {
    try {
      return await conductor.conductAllInScope(scope);
    } catch (error) {
      onScopeError({
        scope,
        error
      });
      return {};
    }
  }));
  return Object.assign({}, ...bags);
};
//# sourceMappingURL=experimentUtils.js.map